import { LogoMark } from '@domain-group/suit-theme'

const LogoNavIcon = (logoKey: string, fillColor?: string) => (
  <LogoMark logoKey={logoKey} fillColor={fillColor} height={16} width={16} />
)

export default LogoNavIcon
